import { render } from "./major.vue?vue&type=template&id=14f2abc8"
import script from "./major.vue?vue&type=script&lang=js"
export * from "./major.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\xiongmao-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__